document.addEventListener('DOMContentLoaded', function () {
	const sections = document.querySelectorAll('.image-toggle');
	sections.forEach(function(section) {
	  section.addEventListener('click', function () {
		sections.forEach(function(otherSection) {
		  if (otherSection !== section) {
			otherSection.classList.remove('active');
		  }
		});
		this.classList.toggle('active');
	  });
	});
  });